<template>
  <div class="mine page">
    <div class="wrapper">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        
        <!-- 顶部用户信息区域（浅紫渐变背景） -->
        <div class="top-bg">
          <!-- 顶部导航占位（无图标） -->
          <van-nav-bar class="nav-bar">
            <template #right>
              <!-- 设置按钮已删除 -->
            </template>
          </van-nav-bar>
          
          <!-- 用户头像与信息 -->
          <div class="user-info-wrap">
            <div class="avatar-border" @click="doLogin()">
              <img class="avatar" src="/img/logo.png" />
            </div>
            
            <div class="user-info">
              <div class="username-row">
                <span class="username">{{ userInfo.username || $t("setting.log_reg") }}</span>
				<span class="lv-badge" v-if="userInfo.lv_name">{{ userInfo.lv_name }}</span>
              </div>
              <div class="user-id">ID: {{ userInfo.id || '-' }}</div>
              <div class="user-score">{{ $t("foorter.top20") }}: {{ userInfo.score || 0 }}</div>
            </div>
            
            <van-icon name="arrow" class="arrow-icon" @click="doLogin()" />
          </div>
        </div>

        <!-- 主体内容（悬浮卡片） -->
        <div class="main-content">
          
          <!-- 余额卡片 -->
          <div class="balance-card">
            <div class="balance-left">
              <div class="balance-title">{{ $t("my.balance") }}</div>
              <div class="balance-num">{{ userInfo.money || '0.00' }}</div>
            </div>
            <div class="balance-right">
              <span class="currency">{{ $t("reservation.unit") }}</span>
              <van-icon name="replay" class="refresh-icon" @click="shuaxin()" />
            </div>
          </div>

          <!-- 回款 / 购单 两个小卡片 -->
          <div class="action-cards">
<div class="action-card" @click="$router.push({path:'/recharge'})">
<span class="action-text">{{ $t("recharge.recharge") }}</span>
<img src="/img/ru.png" style="width: 30px;height: 30px"/>
</div>
            <div class="action-card" @click="doWithdrawal()">
              <span class="action-text">{{ $t("withdraw.with_center") }}</span>
              <img src="/img/hui.png" style="width: 30px;height: 30px"/>
            </div>
           
          </div>

          <!-- 三个入口（账户明细、购单记录、回款记录） -->
          <div class="entry-row">
            <div class="entry-item" @click="$router.push({path:'/RechargeRecord'})">
              <div class="entry-icon "><img src="/img/ruj.png" style="width: 42PX;height: 42PX;border-radius: 10PX"/></div>
              <span class="entry-text">{{$t("foorter.ti_record")}}</span>
            </div>
            <div class="entry-item" @click="$router.push({path:'/WithdrawRecord'})">
              <div class="entry-icon "><van-icon name="cash-back-record" color="#8600ff" size="42PX" /></div>
              <span class="entry-text">{{ $t("withdraw.with_record") }}</span>
            </div>
          </div>

          <!-- 列表菜单（基本信息、修改登录密码、银行卡信息、系统公告） -->
          <div class="menu-list">
            <div class="menu-item" @click="$router.push({path:'/Infomation'})">
              <van-icon name="user-o" size="22PX" color="#432788" />
              <span class="menu-text">{{$t("my.basic_information")}}</span>
              <van-icon name="arrow" class="menu-arrow" color="#999" />
            </div>
            <div class="menu-item" @click="$router.push({path:'/SetLoginPassword'})">
              <van-icon name="lock" size="22PX" color="#432788" />
              <span class="menu-text">{{$t("setting.login_pwd_tip")}}</span>
              <van-icon name="arrow" class="menu-arrow" color="#999" />
            </div>
            <div class="menu-item" @click="$router.push({path:'/Setbank'})">
              <van-icon name="credit-pay" size="22PX" color="#432788" />
              <span class="menu-text">{{$t("setting.bank_info")}}</span>
              <van-icon name="arrow" class="menu-arrow" color="#999" />
            </div>
            <!-- <div class="menu-item" @click="$router.push({path:'/Notice'})">
              <van-icon name="volume-o" size="22PX" color="#432788" />
              <span class="menu-text">{{$t("my.sys_notice")}}</span>
              <van-icon name="arrow" class="menu-arrow" color="#999" />
            </div> -->
          </div>

          <!-- 退出登录按钮 -->
          <div class="logout-btn" @click="loginout()">
            {{$t("setting.logout")}}
          </div>

        </div>
        
        <div style="padding-bottom: 40PX;"></div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {
        header_img: '',
        lv_name: '',
        score: 0,
        money: '0.00'
      },
      isLoading: false,
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' });
        }
      }, 500);
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.kefu = res.data.kefu;
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' });
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' });
      }
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      });
    },
    shuaxin() {
      this.getUserInfo();
      this.$toast(this.$t("reservation.refresh"));
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    toServicePage() {
      window.location.href = this.kefu;
    },
    loginout() {
      localStorage.clear();
      this.$router.push({ path: '/Login' });
    }
  },
  created() {
    this.getBasicConfig();
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  min-height: 100%;
  background: #f7f8fa;
  padding-bottom: 2rem;
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

/* 顶部浅紫渐变背景 */
.top-bg {
  width: 100%;
  height: 150PX;
  background: #8600ff;
  padding-bottom: 60PX;
}

.nav-bar {
  background: transparent;
  height: 20PX;
}

/* 用户信息区域 */
.user-info-wrap {
  display: flex;
  align-items: center;
  padding: 0 6%;
  margin-top: 10PX;
}

.avatar-border {
  width: 68PX;
  height: 68PX;
  border-radius: 50%;
  border: 3PX solid #fff;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.user-info {
  flex: 1;
  margin-left: 15PX;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.username-row {
  display: flex;
  align-items: center;
}

.username {
  font-size: 17PX;
  color: #fff;
  font-weight: 600;
}

.lv-badge {
  margin-left: 8PX;
  font-size: 12PX;
  color: #fff;
  background: linear-gradient(#ffac38, #ffda05);
  padding: 2PX 6PX;
  border-radius: 4PX;
}

.user-id {
  font-size: 13PX;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 4PX;
}

.user-score {
  font-size: 13PX;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 2PX;
}

.arrow-icon {
  color: rgba(255, 255, 255, 0.8);
  font-size: 20PX;
}

/* 主体卡片区域 */
.main-content {
  position: relative;
  width: 92%;
  margin: -30PX auto 0;
  margin-bottom: 60PX;
  z-index: 10;
}

/* 余额卡片 */
.balance-card {
  width: 100%;
  background: #fff;
  border-radius: 16PX;
  padding: 20PX 20PX;
  margin-bottom: 12PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4PX 12PX rgba(0,0,0,0.05);
}

.balance-left {
  display: flex;
  flex-direction: column;
}

.balance-title {
  font-size: 14PX;
  color: #666;
  margin-bottom: 8PX;
}

.balance-num {
  font-size: 28PX;
  font-weight: 800;
  color: #e60012;
}

.balance-right {
  display: flex;
  align-items: center;
}

.currency {
  font-size: 20PX;
  color: #666;
  font-weight: 600;
}

.refresh-icon {
  font-size: 22PX;
  color: #666;
  margin-left: 10PX;
}

/* 回款 / 购单 两个卡片 */
.action-cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12PX;
}

.action-card {
  width: 49%;
  background: #fff;
  border-radius: 16PX;
  padding: 18PX 15PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4PX 12PX rgba(0,0,0,0.05);
  cursor: pointer;
}

.action-text {
  font-size: 16PX;
  font-weight: 600;
  color: #333;
}

/* 三个入口 */
.entry-row {
  display: flex;
  justify-content: space-around;
  background: #fff;
  border-radius: 16PX;
  padding: 20PX 0;
  margin-bottom: 12PX;
  box-shadow: 0 4PX 12PX rgba(0,0,0,0.05);
}

.entry-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.entry-icon {
  width: 42PX;
  height: 42PX;
  border-radius: 10PX;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8PX;
}

.icon-yellow {
  background: #f7b500;
}
.icon-red {
  background: #ff4d4f;
}
.icon-blue {
  background: #1890ff;
}

.entry-text {
  font-size: 13PX;
  color: #333;
}

/* 列表菜单 */
.menu-list {
  background: #fff;
  border-radius: 16PX;
  margin-bottom: 20PX;
  padding: 0 15PX;
  box-shadow: 0 4PX 12PX rgba(0,0,0,0.05);
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 18PX 0;
  border-bottom: 1PX solid #f0f0f0;
  cursor: pointer;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-text {
  flex: 1;
  margin-left: 12PX;
  font-size: 15PX;
  color: #333;
  font-weight: 500;
}

.menu-arrow {
  font-size: 16PX;
}

/* 退出登录按钮 */
.logout-btn {
  width: 100%;
  height: 50PX;
  background: #fff;
  border-radius: 16PX;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16PX;
  font-weight: 600;
  color: #e60012;
  cursor: pointer;
  box-shadow: 0 4PX 12PX rgba(0,0,0,0.05);
  margin-bottom: 20PX;
}
</style>